import httpRequest from "../../../axios/index";
import { ADMIN_CHAT } from "../../../constants/apiEndPoints";
import { toast } from "react-hot-toast";

const GetAllConversations = async (setLoading, SetAllData, type = "") => {
  try {
    setLoading(true);
    let url = `${ADMIN_CHAT}`;
    let params = new URLSearchParams();
    if (type === "CUSTOMER") {
      params.append("type", "customers");
    } else if (type === "DRIVER") {
      params.append("type", "drivers");
    }
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    const resp = await httpRequest.get(`${url}`);
    if (resp?.status === 200) {
      if (resp?.data?.message === "Success") {
        let data = resp?.data?.data?.map((item) => {
          item["user_slug"] = item["sender_slug"]
            ? item["sender_slug"]
            : item["recipient_slug"];
          item["user_name"] = item["sender_name"]
            ? item["sender_name"]
            : item["recipient_name"];
          item["user_image"] = item["sender_image"]
            ? item["sender_image"]
            : item["recipient_image"];
          return item;
        });
        SetAllData({ data: data });
      }
    }
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong");
  } finally {
    setLoading(false);
  }
};

const GetSingleChatByID = async (setLoading, ID, page = 1) => {
  try {
    setLoading(true);
    let url = `${ADMIN_CHAT}`;
    // let params = new URLSearchParams();
    // if (page) {
    //   params.append("page", page);
    // }

    // if (params.toString()) {
    //   url += `?${params.toString()}`;
    // }
    const resp = await httpRequest.get(`${url}/${ID}`);
    return resp;
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong");
  } finally {
    setLoading(false);
  }
};

const UpdateChatUnread = async (ID) => {
  try {
    const resp = await httpRequest.patch(`${ADMIN_CHAT}/${ID}`);
    return resp;
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong");
  }
};

// search the user

const SearchUser = async (setLoading, type = "customers") => {
  try {
    setLoading(true);
    const resp = await httpRequest.get(
      `${ADMIN_CHAT}/users_list/?type=${type}`
    );
    return resp;
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong");
  } finally {
    setLoading(false);
  }
};

// GET /admin/chats/users_list
// type will be customers or drivers

export { GetAllConversations, GetSingleChatByID, UpdateChatUnread, SearchUser };
